"use client";

import Logo from "@/components/Logo";
import React, { useState } from "react";
import Link from "next/link";
import { Navigation24Filled } from "@fluentui/react-icons";
import ListNavigation from "@/components/ListNavigation";

function Navigation({ isUserLoggedIn }: { isUserLoggedIn: boolean }) {
  const [checked, setChecked] = useState<boolean>();
  const handleClick = () => {
    checked ? setChecked(!checked) : setChecked(checked);
  };
  return (
    <div className="drawer max-w-fit">
      <input
        id="my-drawer-3"
        type="checkbox"
        className="drawer-toggle "
        aria-label="menu-toggle"
        checked={checked}
      />
      <div className="drawer-content flex flex-col max-w-fit sm:max-w-full sm:w-full">
        {/* Navbar */}
        <div className="flex-grow navbar ">
          <div className="flex-none">
            <label htmlFor="my-drawer-3" className="items-center">
              <Navigation24Filled />
            </label>
          </div>

          <div className="flex-none">
            <ul className="menu menu-horizontal items-center text-base-content font-medium">
              {/* Site branding */}
              <li className="shrink-0">
                {/* Logo */}
                <Link href="/" className="p-0">
                  <Logo className="group relative cursor-pointer w-20 md:w-full translate-x-8 scale-[1.75] sm:translate-x-0 sm:scale-[1]" />
                </Link>
              </li>
              {/* Navbar menu content here */}
            </ul>
          </div>
        </div>
        {/* Page content here */}
      </div>
      <div className="drawer-side z-20">
        <label
          htmlFor="my-drawer-3"
          className="drawer-overlay"
          aria-label="drawer-navigation"
        ></label>

        <div className="menu w-80 h-full bg-base-100 text-base-content">
          {/* Sidebar content here */}
          <div className="shrink-0 m-3">
            {/* Logo */}
            <Link href="/">
              <Logo className="group relative cursor-pointer" />
            </Link>
          </div>
          {isUserLoggedIn ? (
            <ListNavigation />
          ) : (
            <ul className="menu bg-base-200 rounded-box w-56">
              <li>
                <details>
                  <summary className="text-lg">Pets</summary>
                  <ul>
                    <li>
                      <details>
                        <summary className="text-md">Pets for sale</summary>
                        <ul>
                          <li>
                            <Link href="/sale/dogs">Dogs for sale</Link>
                          </li>
                          <li>
                            <Link href="/sale/cats">Cats for sale</Link>
                          </li>
                        </ul>
                      </details>
                    </li>
                    <li>
                      <details>
                        <summary className="text-md">Pets for adoption</summary>
                        <ul>
                          <li>
                            <Link href="/adoption/cats">Cats for adoption</Link>
                          </li>
                          <li>
                            <Link href="/adoption/dogs">Dogs for adoption</Link>
                          </li>
                        </ul>
                      </details>
                    </li>
                    <li>
                      <Link href="/stud/pets">Pets for stud</Link>
                    </li>
                    <li>
                      <Link href="/breeders" className="text-md">
                        Breeders
                      </Link>
                    </li>
                  </ul>
                </details>
              </li>
              <li>
                <details>
                  <summary className="text-lg">Knowledge hub</summary>
                  <ul>
                    <li>
                      <details>
                        <summary className="text-md">
                          Pet articles & advice
                        </summary>
                        <ul>
                          <li>
                            <Link href="/blog">All articles</Link>
                          </li>
                        </ul>
                      </details>
                    </li>
                    <li>
                      <details>
                        <summary className="text-md">Breed directory</summary>
                        <ul>
                          <li>
                            <Link href="/breeds/dog">Dog breeds</Link>
                          </li>
                          <li>
                            <Link href="/breeds/cat">Cat breeds</Link>
                          </li>
                        </ul>
                      </details>
                    </li>
                  </ul>
                </details>
              </li>
              <li>
                <Link href="/contact" className="text-lg">
                  Contact us
                </Link>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default Navigation;
